// export const BASEURL = `https://brij-api-v1.empirecinemas.com/`;

export const BASEURL = `https://starcinemas-api.nuviotech.co`;
export const SOCKETURL = `https://starcinemas-api.nuviotech.co`;

// export const ImageS3URL = `https://images.brijimages.com/`;
export const IMGBASEURL = `https://star-image.starcinemas.com/`;

export const fallbackImgSrc = `${BASEURL}assets/fallback-image.png`;
export const fallbackImgBannerSrc = `${BASEURL}assets/fallback-image-banner.png`;



// WEBPACK FOOTER //
// ./src/config/index.js